import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import NewsSwiperStore from '@src/business-components/news-swiper/store';
import { PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import styles from './index.less';
/**
 * NewsSwiper
 * @param store {NewsSwiperStore}
 * @returns {JSX.Element}
 * @constructor
 */
const NewsSwiper = ({ store }) => {
  store.use();

  const renderMessageList = () => {
    if (store.isShowList) {
      return (
        <div className={styles.container}>
          {!store.isSwiperStart && <Link className={styles.nextArr} onClick={store.down} />}
          {!store.isSwiperEnd && <Link className={styles.prevArr} onClick={store.up} />}
          <div
            className={cx(styles.swiperContainer, styles.hasTransition)}
            style={{
              transform: `translateY(${store.slideValueRem})`,
              top: store.topRem
            }}
          >
            {store.messageList.map((item, key) => {
              if (store.activeIndex === key) {
                return (
                  <div className={cx(styles.activeSlide, styles.slide, styles[`slide${key + 1}`])} onClick={() => store.onMessageItemClick(item)} key={key} />
                );
              } else if (store.activeIndex + 1 === key) {
                return <div className={cx(styles.nextSlide, styles.slide, styles[`slide${key + 1}`])} key={key} />;
              } else if (store.activeIndex - 1 === key) {
                return <div className={cx(styles.prevSlide, styles.slide, styles[`slide${key + 1}`])} key={key} />;
              }
            })}
          </div>
        </div>
      );
    }
  };

  return (
    <div className={cx(styles.root)}>
      {renderMessageList()}
      {store.messageList.length && (
        <PhotoSlider
          maskOpacity={0.7}
          images={[{ src: store.messageList[store.activeIndex].message_img, key: 0 }]}
          visible={store.lightBoxShowStatus}
          onClose={() => {
            store.lightBoxShowStatus = false;
          }}
          index={0}
        />
      )}
    </div>
  );
};

export default wrapStore(NewsSwiper, NewsSwiperStore);
